<template>
    <div id="noprint">
        <v-app-bar fixed app :clipped-left="$vuetify.breakpoint.lgAndUp" dark color="brand" class="d-print-none app app-bar">
            <v-app-bar-nav-icon @click.stop="mobileDrawer = !mobileDrawer" class="d-md-none" />
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <!-- <v-switch v-model="isDrawer" inset color="warning" class="ma-2" hide-details @change="handleSwitchChange"
                aria-label="Toggle Sidebar"></v-switch> -->
            <label class="toggle-switch">
                <input type="checkbox" id="toggle-switch" v-model="isDrawer" @change="handleSwitchChange">
                <span class="slider"></span>
            </label>

            <v-toolbar-title style="color: var(--v-onBrand-base);margin-left: 20px; font-weight: bold;" class="mt-1 org-name">{{ org_name
                }}</v-toolbar-title>

            <v-spacer />

            <div class="d-none d-md-flex align-center header-icons">
                <router-link to="/home" class="mr-2">
                    <v-icon class="icon" title="Home">mdi-home</v-icon>
                </router-link>

                <v-btn icon v-if="IsAdminRole">
                    <v-icon color="white" @click="SwitchToAdmin()" title="Switch">mdi-account-switch</v-icon>
                </v-btn>

                <!-- Bypass Logout -->
                <v-avatar v-if="is_school_bypass_login">
                    <v-icon class="icon" title="Bypass Logout" @click="bypasslogout()">mdi-location-exit</v-icon>
                </v-avatar>

                <!-- Dashboard -->
                <v-btn icon v-if="usertype === 'Parent'">
                    <v-icon title="Analytical Dashboard" @click="analyticalStats()">mdi-gauge</v-icon>
                </v-btn>
                <v-btn icon v-if="usertype === 'Employee'">
                    <v-icon title="Analytical Dashboard" @click="analyticalStatsEmp()">mdi-gauge</v-icon>
                </v-btn>

                <!-- Master Data -->
                <v-btn icon v-if="usertype !== 'Parent' && usertype !== 'Student'">
                    <v-icon title="Master Data" @click="getMasterData()">mdi-database</v-icon>
                </v-btn>

                <!-- Settings -->
                <v-btn icon v-if="usertype !== 'Parent' && usertype !== 'Student'">
                    <v-icon title="Settings" @click="showSettings()">mdi-cog</v-icon>
                </v-btn>

                <!-- Calendar -->
                <v-btn icon v-if="show_calendarnew">
                    <v-icon title="Calendar of Events" @click="OpenDialogBoxForShowCalender()">mdi-calendar</v-icon>
                </v-btn>

                <!-- Notifications -->
                <v-btn icon>
                    <v-badge v-if="unreadCount > 0" :content="unreadCount" color="red" overlap>
                        <template #badge>
                            <span class="text-white">{{ unreadCount }}</span>
                        </template>
                        <v-icon title="Notifications" @click="showNotifications()">mdi-bell-ring</v-icon>
                    </v-badge>
                    <v-icon v-else title="Notifications" @click="showNotifications()">mdi-bell-ring</v-icon>
                </v-btn>

                <!-- Feedbacks -->
                <!-- <v-avatar v-if="feedback_notification_count > 0">
                    <v-badge :content="feedback_notification_count" color="red" overlap>
                        <template #badge>
                            <span class="text-white">{{ feedback_notification_count }}</span>
                        </template>
                        <v-icon title="Feedbacks"
                            @click.stop="menu_for_feedback = true">mdi-message-text-outline</v-icon>
                    </v-badge>
                </v-avatar> -->

                <v-btn icon v-if="feedback_notification_count > 0" :href="resolve_feedback_link">
                    <v-badge :content="feedback_notification_count" color="red" overlap>
                        <template #badge><span class="text-white">{{ feedback_notification_count }}</span></template>
                        <v-icon title="Feedbacks">mdi-message-text-outline</v-icon>
                    </v-badge>
                </v-btn>

                <!-- Help -->
                    <v-btn icon>
                        <v-icon title="Help">mdi-comment-question-outline</v-icon>
                    </v-btn>

                <!-- Leave Policy -->
                <v-btn icon v-if="tenant === 'wws' && org_id === '1' && usertype === 'Employee'" 
                        href="https://eduplusschool.s3.ap-south-1.amazonaws.com/logo/Leave+policy_WWS.pdf" target="_blank">
                    <v-icon title="Leave Policy">mdi-eye</v-icon>
                </v-btn>

                <v-btn icon v-if="tenant === 'wws' && org_id === '2' && usertype === 'Employee'" 
                        href="https://eduplusschool.s3.ap-south-1.amazonaws.com/logo/Leave+policy_WWS+Hadapsar.pdf" target="_blank">
                    <v-icon title="Leave Policy">mdi-eye</v-icon>
                </v-btn>
                <!-- Language -->

                <v-btn icon>
                    <v-icon @click="openLanguageDialog()" title="Language">mdi-translate-variant</v-icon>
                </v-btn>


                <!-- Theme Button -->
                <v-btn icon @click="openThemePopup" aria-label="Theme">
                    <v-icon title="Color theme" color="white">mdi-palette</v-icon>
                </v-btn>


                <!-- Chatbot -->
                <v-avatar>
                    <v-icon title="Chatbot">mdi-robot-happy-outline</v-icon>
                </v-avatar>

                <!-- More Features -->
                <div>
                    <v-avatar>
                        <v-icon title="More Features">mdi-apps</v-icon>
                    </v-avatar>
                </div>

                <!-- Speech to Text -->
                <v-btn icon>
                    <v-icon title="Speech to Text" @click="dialog_speechtotext = true">mdi-microphone</v-icon>
                </v-btn>

                <!-- Editor -->
                <v-btn icon>
                    <v-icon title="Editor" @click="openEditor()">mdi-file-edit-outline</v-icon>
                </v-btn>

                <!-- FAQ -->
                <v-btn icon v-if="usertype !== 'Parent' && usertype !== 'Student'">
                    <v-icon title="Frequently Asked Questions" @click="faq">mdi-information-variant</v-icon>
                </v-btn>
                <div class="text-right mb-2 mt-2 hidden-sm-and-down">
                    <v-avatar v-if="!firefoxAgent" class="ma-2 white--text" size="50" outlined>
                        <Speed />
                    </v-avatar>
                </div>
            </div>

            <v-menu offset-y v-if="$vuetify.breakpoint.mdAndDown">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                </template>
                <v-list dense>
                    <!-- Home -->
                    <v-list-item to="/home" class="sidebar-link">
                        <v-list-item-icon><v-icon>mdi-home</v-icon></v-list-item-icon>
                        <v-list-item-title>Home</v-list-item-title>
                    </v-list-item>

                    <!-- Analytical Dashboard -->
                    <v-list-item v-if="usertype === 'Parent'" @click="analyticalStats()">
                        <v-list-item-icon><v-icon>mdi-gauge</v-icon></v-list-item-icon>
                        <v-list-item-title>Dashboard</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="usertype === 'Employee'" @click="analyticalStatsEmp()">
                        <v-list-item-icon><v-icon>mdi-gauge</v-icon></v-list-item-icon>
                        <v-list-item-title>Dashboard</v-list-item-title>
                    </v-list-item>

                    <!-- Master Data -->
                    <v-list-item v-if="usertype !== 'Parent' && usertype !== 'Student'" @click="getMasterData()">
                        <v-list-item-icon><v-icon>mdi-database</v-icon></v-list-item-icon>
                        <v-list-item-title>Master Data</v-list-item-title>
                    </v-list-item>

                    <!-- Settings -->
                    <v-list-item v-if="usertype !== 'Parent' && usertype !== 'Student'" @click="showSettings()">
                        <v-list-item-icon><v-icon>mdi-cog</v-icon></v-list-item-icon>
                        <v-list-item-title>Settings</v-list-item-title>
                    </v-list-item>

                    <!-- Calendar -->
                    <v-list-item v-if="show_calendarnew" @click="OpenDialogBoxForShowCalender()">
                        <v-list-item-icon><v-icon>mdi-calendar</v-icon></v-list-item-icon>
                        <v-list-item-title>Calendar</v-list-item-title>
                    </v-list-item>

                    <!-- Notifications -->
                    <v-list-item @click="showNotifications()">
                        <v-list-item-icon>
                            <v-badge v-if="unreadCount > 0" :content="unreadCount" color="red" overlap>
                                <v-icon>mdi-bell-ring</v-icon>
                            </v-badge>
                            <v-icon v-else>mdi-bell-ring</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Notifications</v-list-item-title>
                    </v-list-item>

                    <!-- Feedbacks -->
                    <v-list-item v-if="feedback_notification_count > 0" @click.stop="menu_for_feedback = true">
                        <v-list-item-icon>
                            <v-badge :content="feedback_notification_count" color="red" overlap>
                                <v-icon>mdi-message-text-outline</v-icon>
                            </v-badge>
                        </v-list-item-icon>
                        <v-list-item-title>Feedbacks</v-list-item-title>
                    </v-list-item>

                    <!-- Help -->
                    <v-list-item>
                        <v-list-item-icon><v-icon>mdi-comment-question-outline</v-icon></v-list-item-icon>
                        <v-list-item-title>Help</v-list-item-title>
                    </v-list-item>

                    <!-- Leave Policy -->
                    <v-list-item v-if="tenant === 'wws' && org_id === '1' && usertype === 'Employee'">
                        <v-list-item-icon>
                            <a href="https://eduplusschool.s3.ap-south-1.amazonaws.com/logo/Leave+policy_WWS.pdf"
                                target="_blank">
                                <v-icon>mdi-eye</v-icon>
                            </a>
                        </v-list-item-icon>
                        <v-list-item-title>Leave Policy</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="tenant === 'wws' && org_id === '2' && usertype === 'Employee'">
                        <v-list-item-icon>
                            <a href="https://eduplusschool.s3.ap-south-1.amazonaws.com/logo/Leave+policy_WWS+Hadapsar.pdf"
                                target="_blank">
                                <v-icon>mdi-eye</v-icon>
                            </a>
                        </v-list-item-icon>
                        <v-list-item-title>Leave Policy</v-list-item-title>
                    </v-list-item>

                    <!-- Language -->
                    <!-- <v-list-item>
                        <v-list-item-icon><v-icon>mdi-translate-variant</v-icon></v-list-item-icon>
                        <v-list-item-title>Language</v-list-item-title>
                    </v-list-item> -->

                    <!-- Theme -->
                    <v-list-item @click="openThemePopup">
                        <v-list-item-icon><v-icon>mdi-palette</v-icon></v-list-item-icon>
                        <v-list-item-title>Theme</v-list-item-title>
                    </v-list-item>

                    <!-- Chatbot -->
                    <v-list-item>
                        <v-list-item-icon><v-icon>mdi-robot-happy-outline</v-icon></v-list-item-icon>
                        <v-list-item-title>Chatbot</v-list-item-title>
                    </v-list-item>

                    <!-- More Features -->
                    <v-list-item>
                        <v-list-item-icon><v-icon>mdi-apps</v-icon></v-list-item-icon>
                        <v-list-item-title>More Features</v-list-item-title>
                    </v-list-item>

                    <!-- Speech to Text -->
                    <v-list-item @click="dialog_speechtotext = true">
                        <v-list-item-icon><v-icon>mdi-microphone</v-icon></v-list-item-icon>
                        <v-list-item-title>Speech to Text</v-list-item-title>
                    </v-list-item>

                    <!-- Editor -->
                    <v-list-item @click="openEditor()">
                        <v-list-item-icon><v-icon>mdi-file-edit-outline</v-icon></v-list-item-icon>
                        <v-list-item-title>Editor</v-list-item-title>
                    </v-list-item>

                    <!-- FAQ -->
                    <v-list-item v-if="usertype !== 'Parent' && usertype !== 'Student'" @click="faq">
                        <v-list-item-icon><v-icon>mdi-information-variant</v-icon></v-list-item-icon>
                        <v-list-item-title>FAQ</v-list-item-title>
                    </v-list-item>
                    <!-- Bypass Logout -->
                    <v-list-item v-if="is_school_bypass_login" @click="bypasslogout()">
                        <v-list-item-icon><v-icon>mdi-location-exit</v-icon></v-list-item-icon>
                        <v-list-item-title>Bypass Logout</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>

            <div class="text-right ml-2">
                <v-menu v-model="menu" :close-on-content-click="true" offset-x transition="scroll-y-transition">
                    <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on" class="profile-btn">
                            <v-avatar v-if="user_type === 'Employee'" class="glow-avatar" size="40">
                                <v-img v-if="profile_image_path"
                                    :src="awspath + profile_image_path + profile_image_name" />
                                <span v-else class="text-subtitle-2 font-weight-bold">{{ initials }}</span>
                            </v-avatar>
                            <v-avatar v-else class="glow-avatar" size="40">
                                <v-img v-if="learnerPhotoPath" :src="awspath + learnerPhotoPath" />
                                <span v-else class="text-subtitle-2 font-weight-bold">{{ initials }}</span>
                            </v-avatar>
                        </v-btn>
                    </template>
                    <v-card class="rounded-card profile-card">
                        <v-list class="profile-header py-4">
                            <v-list-item>
                                <v-list-item-avatar>
                                    <v-avatar size="50" v-if="user_type === 'Employee'">
                                        <v-img v-if="profile_image_path"
                                            :src="awspath + profile_image_path + profile_image_name" />
                                        <v-avatar v-else color="white">
                                            <span class="text-subtitle-2 font-weight-bold">{{ initials }}</span>
                                        </v-avatar>
                                    </v-avatar>
                                    <v-avatar size="50" v-else>
                                        <v-img v-if="learnerPhotoPath" :src="awspath + learnerPhotoPath" />
                                        <v-avatar v-else color="white">
                                            <span class="text-subtitle-2 font-weight-bold">{{ initials }}</span>
                                        </v-avatar>
                                    </v-avatar>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                    <v-list-item-title class="text-h6 mb-1">Hello, {{ username }}</v-list-item-title>
                                    <div class="info-chip pa-2">
                                        <v-list-item-subtitle v-if="code">{{ code }}</v-list-item-subtitle>
                                        <v-list-item-subtitle v-if="uid">{{ uid }}</v-list-item-subtitle>
                                        <v-list-item-subtitle v-if="designation">{{ designation
                                            }}</v-list-item-subtitle>
                                    </div>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                        <v-divider />
                        <v-list dense>
                            <v-list-item-group color="primary">
                                <v-list-item class="list-hover" @click="profile_link()" v-if="!(hide_user_profile && usertype === 'Student')">
                                    <v-list-item-icon>
                                        <v-icon color="#7E57C2">mdi-account-circle-outline</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>User Profile</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item v-if="ut === 'Parent'" class="list-hover" @click="application_form()">
                                    <v-list-item-icon>
                                        <v-icon color="#7E57C2">mdi-school</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>New Admission Form</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <!-- <v-list-item class="list-hover" @click="virtual_card_link()">
                                    <v-list-item-icon>
                                        <v-icon color="#7E57C2">mdi-card-account-details-outline</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>Virtual Card</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item> -->
                                <router-link to="/update-password" class="sidebar-link">
                                    <v-list-item class="list-hover">
                                        <v-list-item-icon>
                                            <v-icon color="#7E57C2">mdi-lock-reset</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>Change Password</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </router-link>
                            </v-list-item-group>
                        </v-list>
                        <v-divider />
                        <v-card-actions class="justify-space-between">
                            <v-btn small color="warning" v-if="show_bypasslogout" @click="bypasslogout()"
                                title="Bypass Logout">
                                Bypass Logout
                            </v-btn>
                            <v-spacer></v-spacer>
                            <!-- <div class="signout-wrap"> -->
                                <v-btn text @click="closeMenuAndLogout()" color="#b71c1c">
                                    <v-icon small class="mr-1" color="error">mdi-logout</v-icon>
                                Sign Out</v-btn>
                                <!-- <span class="signout-text" @click="closeMenuAndLogout()"></span> -->
                            <!-- </div> -->
                        </v-card-actions>
                    </v-card>
                </v-menu>

            </div>

            <v-dialog v-model="DialogBoxForShowCalender" max-width="500" persistent>
                <v-card>
                    <v-card-title class="headline grey lighten-2">Notification</v-card-title>
                    <v-card-text v-if="conf_value && conf_link">
                        <v-row>
                            <v-col cols="12">
                                <li style="font-size: medium; font-weight: bold;" v-html="conf_value"></li>
                            </v-col>
                            <v-col cols="12">
                                <span style="font-size: medium; font-weight: bold;">Attachment:</span>
                                <a :href="conf_link" target="_blank">
                                    <v-icon color="green">mdi-attachment</v-icon>
                                </a>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-divider />
                    <v-card-actions class="justify-center">
                        <v-btn color="primary" text @click="cancelDialogBoxForShowCalender()" outlined>Close</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialog_speechtotext" width="1000px">
                <v-card>
                    <v-col cols="12" sm="12" md="12">
                        <v-card class="box">
                            <v-toolbar class="toolbar" flat dense>
                                <v-btn icon dark @click="dialog_speechtotext = false">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                                <v-toolbar-title>Speech To Text</v-toolbar-title>
                            </v-toolbar>
                        </v-card>
                        <!-- calendar content start -->

                        <v-card class="box">
                            <speech-to-text></speech-to-text>
                        </v-card>
                        <!-- calendar content end -->
                    </v-col>
                </v-card>
            </v-dialog>

            <v-dialog v-model="language_dialog" max-width="600" persistent>
                <v-card>
                    <v-toolbar class="toolbar" flat dense>

                        <v-toolbar-title>Language</v-toolbar-title>
                    </v-toolbar>
                    <br>

                    <v-card-text>
                        <v-row class="justify-center">
                            <v-col cols="12" sm="9" md="9">
                                <p><v-icon color="error">*</v-icon><span style="font-weight:bold;">Please Select
                                        Language</span></p>

                                <v-autocomplete v-model="selected_language" :items="language_master_list"
                                    item-text="name" return-object outlined dense>
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row class="justify-center"> <v-col cols="12" sm="5" md="5" class="justify-center">
                                <v-btn class="mb-2 button" @click="savePreferredLanguage()">Save</v-btn>
                                <v-btn class="mb-2 button" @click="language_dialog = false">Close</v-btn>

                            </v-col></v-row>

                    </v-card-text>
                </v-card>
            </v-dialog>


        </v-app-bar>

        <v-navigation-drawer v-model="mobileDrawer" app temporary class="d-md-none">
            <v-app-bar dense color="brand" flat dark>
                <v-toolbar-title class="text-subtitle-1">Menu</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="mobileDrawer = false" title="Close Drawer">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                
            </v-app-bar>
            <!-- Top Search Bar -->
            <v-app-bar dense color="brand" flat>
                <v-text-field v-model="moduleSearch" placeholder="Search module..." append-icon="mdi-magnify" dense solo
                    rounded hide-details class="search-bar" :dark="false"></v-text-field>
            </v-app-bar>
            <v-list dense nav>
                <span v-for="(item, j) in filteredItems" :key="j">
                    <v-list-group v-if="item.children.length > 1" no-action>
                        <template v-slot:activator>
                            <v-list-item-avatar size="30"><v-img :src="item.icon"></v-img></v-list-item-avatar>
                            <v-list-item-content><v-list-item-title>{{ item.name
                                    }}</v-list-item-title></v-list-item-content>
                        </template>
                        <v-list-item v-for="(child, k) in item.children" :key="k" @click="openlink(child)">
                            <v-list-item-avatar size="24" class="ml-2"><v-img :src="child.icon" /></v-list-item-avatar>
                            <v-list-item-title>{{ child.name }}</v-list-item-title>
                        </v-list-item>
                    </v-list-group>
                    <v-list-item v-else @click="openlink(item.children[0])">
                        <v-list-item-avatar size="30"><v-img :src="item.icon"></v-img></v-list-item-avatar>
                        <v-list-item-content><v-list-item-title>{{ item.name
                                }}</v-list-item-title></v-list-item-content>
                    </v-list-item>
                </span>
            </v-list>
        </v-navigation-drawer>


        <span v-if="$vuetify.breakpoint.mdAndUp">
            <span v-if="user_type == 'Employee'">
                <span v-if="isDrawer" class="no-display">
                    <v-navigation-drawer v-if="isDrawer" app style="margin-top: 3.9%;  border-radius: 0 12px 12px 0;"
                        permanent expand-on-hover :mini-variant.sync="mini" :temporary="$vuetify.breakpoint.smAndDown"
                        elevation="10" color="#f5f5f5">
                        <!-- Top Search Bar -->
                        <v-app-bar v-if="!mini" dense color="brand" flat>
                            <v-text-field v-model="moduleSearch" placeholder="Search module..."
                                append-icon="mdi-magnify" dense solo rounded hide-details class="search-bar"
                                :dark="false"></v-text-field>
                        </v-app-bar>
                        <v-list dense nav>
                            <template v-if="loading">
                                <v-list-item v-for="n in placeholderMenuCount" :key="'sk-'+n">
                                <v-skeleton-loader class="mb-3"
                            type="avatar"
                            width="38"
                            height="38"
                            style="border-radius: 50%;"
                        ></v-skeleton-loader>

                                </v-list-item>
                            </template>

                            <template v-else>
                            <span v-for="(item, j) in filteredItems" :key="j">
                                <v-list-group v-if="item.children.length > 1" no-action>
                                    <template v-slot:activator>
                                        <v-list-item-avatar size="30"><v-img
                                                :src="item.icon"></v-img></v-list-item-avatar>
                                        <v-list-item-content><v-list-item-title>{{ item.name
                                                }}</v-list-item-title></v-list-item-content>
                                    </template>
                                    <v-list-item v-for="(child, k) in item.children" :key="k" @click="openlink(child)">
                                        <v-img :src="child.icon" width="20" height="20" class="mr-1"></v-img>
                                        <v-list-item-title>{{ child.name }}</v-list-item-title>
                                    </v-list-item>
                                </v-list-group>
                                <v-list-item v-else @click="openlink(item.children[0])">
                                    <v-list-item-avatar size="30"><v-img :src="item.icon"></v-img></v-list-item-avatar>
                                    <v-list-item-content><v-list-item-title>{{ item.name
                                            }}</v-list-item-title></v-list-item-content>
                                </v-list-item>
                            </span>
                             </template>
                        </v-list>
                    </v-navigation-drawer>
                </span>
                <span v-if="!isDrawer && isDrawer1">
                    <v-container fluid class="mt-9 mb-0 pb-0">
                        <!-- <v-row> -->
                        <v-row>
                            <v-col cols="12" md="9">
                                <v-card flat class="pa-2 mb-0" color="brandLight" style="margin-top: 16px;"> <!-- Light Brand color set"-->
                                    <v-row dense justify="center">
                                        <v-col cols="12" sm="3" md="6">
                                            <v-text-field v-model="moduleSearch" append-icon="mdi-magnify"
                                                background-color="white" hide-details label="Search module" dense
                                                outlined />
                                        </v-col>

                                        <v-col cols="12" sm="3" md="6">
                                            <v-combobox dense clearable :items="search_links" item-text="name"
                                                background-color="white" hide-details v-model="goto_link"
                                                label="Search links" outlined return-object @change="gotoLink">
                                                <template v-slot:append>
                                                    <v-icon class="cursor-pointer"
                                                        @click="gotoLink">mdi-magnify</v-icon>
                                                </template>
                                            </v-combobox>
                                        </v-col>
                                    </v-row>
                                </v-card><br>
                                <v-card flat color="brandLight" class="pa-3" style="border-radius: 16px;"> <!-- Light Brand color set"-->
                                    <v-row dense justify="center">
                                        <template v-if="loading">
                                            <v-col
                                                v-for="n in placeholderCount"
                                                :key="n"
                                                cols="auto"
                                            >
                                                <v-skeleton-loader
                                                    type="image"
                                                    class="ma-2"
                                                    width="170"
                                                    height="120"
                                                    style="border-radius: 12px"
                                                />
                                            </v-col>
                                        </template>                       
                                        <template v-else>             
                                        <v-col v-for="(item, j) in filteredItems" :key="j" cols="auto">
                                            <!-- Color set as "Brand" for theme change, Brand is declared in vuetify.js-->
                                            <v-card :elevation="2"   
                                                class="d-flex flex-column align-center justify-center text-center link-card ma-2 brand-light-card"
                                                @click="item.children.length !== 1 ? openEmpRole1(item.children) : openlink1(item.children[0])">
                                               <div>
                                                    <img class="icon-wrapper" :src="item.icon" width="45" height="45" />
                                                </div>

                                                <div><strong class="linkname">{{ item.name }}</strong></div>
                                            </v-card>
                                        </v-col>
                                        </template> 
                                    </v-row>
                                </v-card>
                            </v-col>
                            <v-col cols="12" md="3">
                                <updated-employee-right-section />
                            </v-col>
                        </v-row>
                    </v-container>
                </span>
            </span>
            <span v-else>
                <span v-if="isDrawer" class="no-display">
                    <v-navigation-drawer v-if="isDrawer" app style="margin-top: 3.9%;  border-radius: 0 12px 12px 0;"
                        permanent expand-on-hover :mini-variant.sync="mini" :temporary="$vuetify.breakpoint.smAndDown"
                        elevation="10" color="#f5f5f5">
                        <!-- Top Search Bar -->
                        <v-app-bar v-if="!mini" dense color="brand" flat>
                            <v-text-field v-model="moduleSearch" placeholder="Search module..."
                                append-icon="mdi-magnify" dense solo rounded hide-details class="search-bar"
                                :dark="false"></v-text-field>
                        </v-app-bar>
                        <v-list dense nav>
                            <span v-for="(item, j) in filteredItems" :key="j">
                                <v-list-group v-if="item.children.length > 1" no-action>
                                    <template v-slot:activator>
                                        <v-list-item-avatar size="30"><v-img
                                                :src="item.icon"></v-img></v-list-item-avatar>
                                        <v-list-item-content><v-list-item-title>{{ item.name
                                                }}</v-list-item-title></v-list-item-content>
                                    </template>
                                    <v-list-item v-for="(child, k) in item.children" :key="k" @click="openlink(child)">
                                        <v-list-item-avatar size="24" class="ml-2"><v-img
                                                :src="child.icon" /></v-list-item-avatar>
                                        <v-list-item-title>{{ child.name }}</v-list-item-title>
                                    </v-list-item>
                                </v-list-group>
                                <v-list-item v-else @click="openlink(item.children[0])">
                                    <v-list-item-avatar size="30"><v-img :src="item.icon"></v-img></v-list-item-avatar>
                                    <v-list-item-content><v-list-item-title>{{ item.name
                                            }}</v-list-item-title></v-list-item-content>
                                </v-list-item>
                            </span>
                        </v-list>
                    </v-navigation-drawer>
                </span>
                <span v-if="!isDrawer && isDrawer1">

                    <v-container fluid class="mt-9">
                        <v-row>
                            <v-col cols="12">
                                <v-card class="pa-2 mb-0" color="brandLight" style="margin-top: 30px;"> <!-- Light Brand color set"-->
                                    <v-row dense justify="center">
                                        <v-col cols="12" sm="3" md="6">
                                            <v-text-field v-model="moduleSearch" append-icon="mdi-magnify"
                                                background-color="white" hide-details label="Search module" dense
                                                outlined />
                                        </v-col>

                                        <v-col cols="12" sm="3" md="6">
                                            <v-combobox dense clearable :items="search_links" item-text="name"
                                                background-color="white" hide-details v-model="goto_link"
                                                label="Search links" outlined return-object @change="gotoLink">
                                                <template v-slot:append>
                                                    <v-icon class="cursor-pointer"
                                                        @click="gotoLink">mdi-magnify</v-icon>
                                                </template>
                                            </v-combobox>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </v-col>
                        </v-row>

                        <!-- <v-col cols="12" md="12"> -->
                        <v-card color="brandLight" class="pa-3" style="border-radius: 16px;">    <!-- Light Brand color set"-->                    
                                <v-row dense>
                                    <v-col v-for="(item, j) in filteredItems" :key="j" cols="auto"
                                        >
                                        <v-card :elevation="2" color="brand" class="d-flex flex-column align-center justify-center text-center link-card ma-2"
                                             
                                            @click="item.children.length !== 1 ? openEmpRole1(item.children) : openlink1(item.children[0])">
                                            <img :src="item.icon" cover contain width="40" height="40" class="mb-3"/>
                                            <div><strong class="linkname text-center">{{ item.name }}</strong></div>
                                        </v-card>
                                    </v-col>
                                </v-row>                          
                        </v-card>
                    </v-container>

                </span>
            </span>
        </span>
        <span v-else>
            <span v-if="!isDrawer && isDrawer1">
                <v-container fluid class="mt-9 mb-0 pb-0">
                    <v-card class="pa-2 mb-0" color="brandLight" style="margin-top: 30px;"> <!-- Light Brand color set"-->
                        <v-row justify="left" class="mb-0 pb-0">
                            <v-col cols="12" sm="4" md="3" class="mb-0 pb-0">
                                <v-text-field v-model="moduleSearch" append-icon="mdi-magnify" label="Search module"
                                    dense background-color="white" hide-details outlined />
                            </v-col>
                            <v-col cols="12" sm="4" md="3" class="mb-0 pb-0">
                                <v-combobox dense clearable :items="search_links" item-text="name" v-model="goto_link"
                                    background-color="white" hide-details label="Search links" outlined return-object
                                    @change="gotoLink">
                                    <template v-slot:append>
                                        <v-icon class="cursor-pointer" @click="gotoLink">mdi-magnify</v-icon>
                                    </template>
                                </v-combobox>
                            </v-col>
                        </v-row>
                    </v-card>
                    <v-row class="mt-0 pb-0">
                        <v-col cols="12" md="9">
                            <v-card color="brandLight" style="border-radius: 16px;"> <!-- Light Brand color set"-->
                                <v-card-text>
                                    <v-row dense>
                                        <v-col v-for="(item, j) in filteredItems" :key="j" cols="12" sm="6" md="4"
                                            lg="3">
                                            <!--Brand color set down here"-->
                                            <v-card :elevation="2" color="brand" class="back-hover mb-3" 
                                                @click="item.children.length !== 1 ? openEmpRole1(item.children) : openlink1(item.children[0])">
                                                
                                                <v-img>
                                                    <v-container class="text-center">
                                                        <v-img :src="item.icon" max-width="25%" class="mx-auto" />
                                                        <strong class="linkname">{{ item.name }}</strong>
                                                    </v-container>
                                                </v-img>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="3">
                            <updated-employee-right-section class="mt-4" />
                        </v-col>
                    </v-row>
                </v-container>
            </span>
        </span>
        <ThemePopup ref="tPopup" />
    </div>
</template>

<script>
import ThemePopup from "@/components/shared/themePopup.vue"; //
import axios from "axios";
import Speed from "./Speed";
import UpdatedEmployeeRightSection from "@/components/shared/UpdatedEmployeeRightSection.vue";
export default {
    components: {
        ThemePopup,
        Speed,
        UpdatedEmployeeRightSection,
        parentProfileCard: () => import("./ParentProfileCard.vue"),
        parentUpcomingEvents: () => import("./ParentUpcomingEvents.vue"),
        instructor_calendar: () => import("../Academics/AcademicPlanner/InstructorCalendar"),
        editer: () => import("../Editer"),
        "speech-to-text": () => import("../TryNError/SpeechToText"),
        updatedEmployeeProfileCard: () => import("./UpdatedEmployeeProfileCard.vue"),

    },
    data: () => ({
        editorConfig: {
            height: "100px",
            extraPlugins: "mathjax",
            mathJaxLib: "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.1/MathJax.js?config=TeX-AMS_HTML",
        },

        mini: true,
        initials: "",
        mobileDrawer: false,
        awspath: "",
        policy_read: false,
        comm_history: [],

        send_otp_btn_load: false,
        error: false,
        email_msg: null,
        error_message: "",
        error1: false,
        error_message1: "",
        hideen: true,
        dialog_calendar: false,
        dialog_speechtotext: false,
        dialog_Editor: false,
        disabled: 0,
        isClosed: false,
        isLoading: false,
        user_type: null,
        show_calendarnew: false,
        events: [],
        user: {
            otp_id: "",
            email: "",
            email_otp: "",
            mobile: "",
            mobile_otp: "",
            dns: "",
        },
        parent_email: "",
        rules: {
            required: (value) => !!value || "Required.",
            uid: (value) => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return pattern.test(value) || "Invalid e-mail.";
            },
        },
        show_parent_uid: false,
        items: [],
        drawer: false,
        isDarkMode: false,
        menu: false,
        showAllApps: false,
        module_link: false,
        search_links: [],
        goto_link: null,
        easycheck_url: "http://localhost:8080", //live url
        lib_url: "http://localhost:8080", //live url
        uid: "",
        prn: "",
        random_key: "",
        hash_key: "",
        flag: false,
        erp_url: "",
        device_name: "",
        erp_easycheck_flag: null,
        erp_lib_flag: null,
        resend_email_otp_load: false,
        temp_card: "card",
        show_parent_uid: false,
        parent_uid: "",
        add_parent_uid: false,
        verify_block: false,
        verify_btn_load: false,
        user_type: null,
        tenant: "sbpps",
        show_addmission_form: false,
        org_code: "",
        code: "",
        dialog_inst_cal: false,
        isDrawer: sessionStorage.getItem("isDrawer") === null
            ? true
            : sessionStorage.getItem("isDrawer") === "true",
        isDrawer1: true,
        moduleSearch: "",
        emp_role: [],
        emp_roles: [],
        dailog_role: false,
        componentData: null,
        isLoading: false,
        loading:true,
        placeholderCount: 8,
        placeholderMenuCount: 11,
        menu: false,
        username: "",
        uid: "",
        designation: "",
        dialog_speechtotext: false,
        data: {},
        profile_image_name: "",
        profile_image_path: "",
        profile: null,
        home_url: null,
        virtual_card: "",
        firefoxAgent: false,
        show: false,
        org_name: null,
        quick_links: [],

        org_logo: "https://eduplusschool.s3.ap-south-1.amazonaws.com/edupluscampus.png",
        usertype: null,
        show_bypasslogout: false,
        ut: null,
        tenant: null,
        reload_cnt: 3,
        is_school_bypass_login: false,
        DialogBoxForShowCalender: false,
        feedback_notification_count: 0,
        resolve_feedback_link: "",
        menu_for_feedback: false,
        conf_link: "",
        conf_value: "",
        learnerPhotoPath: localStorage.getItem("learner_photo_path"),
        language_dialog: false,
        selected_language: "",
        language_master_list: [],
        by_default_or_save_alreadly_language: "",
        old_lang: 'en',
        snackbar_msg: "",
        color: "",
        snackbar: false,
        org_id: null,
        IsAdminRole: false,
        overlay: false,
        IsSwitched: sessionStorage.getItem('IsSwitched') === 'true',
        hide_user_profile:false,
    }),
    created() {

        this.tenant = localStorage.getItem("EPS-tenant");
        this.org_id = localStorage.getItem("EPS-org-id");
        this.user_type = localStorage.getItem("EPS-ut");
        window.addEventListener("visibilitychange", this.updatePhotoPath);
        this.isDrawer = sessionStorage.getItem("isDrawer") === null
            ? true
            : sessionStorage.getItem("isDrawer") === "true";

        if (localStorage.getItem("EPS-ut") == "Parent") {
            if (this.tenant == "wws" || this.tenant == "vvp" || this.tenant == "eps" || this.tenant == "sbpps" || this.tenant == "sanjivani" || this.tenant == "uwws") {
                this.ut = "Parent";
            }

        } else if (localStorage.getItem("EPS-ut") == "Employee") {


        } else {
        }
    },

    beforeDestroy() {
        window.removeEventListener("visibilitychange", this.updatePhotoPath);
    },
    beforeDestroy() {
        clearInterval(this.poller);
    },
    computed: {
        filteredItems() {
            if (!this.moduleSearch) return this.items;
            return this.items.filter((item) => item.name && item.name.toLowerCase().includes(this.moduleSearch.toLowerCase()));
        },

        unreadCount() {
            return this.comm_history.filter(item => !item.is_read).length;

        },
    },
    methods: {

        // ---- Open Theme Popup ----
        openThemePopup() {
            this.$refs.tPopup.open();
        },

        // ---- Open Dialog ----
        openLanguageDialog() {
            this.language_dialog = true;
        },

        // ---- Fetch Available Languages ----
        getLanguages() {
            this.overlay = true;
            axios.post("/Home/getPreferredLanguage")
                .then((res) => {
                    this.overlay = false;

                    if (res.data.msg === "200") {
                        this.language_master_list = res.data.language_master_list;
                        this.by_default_or_save_alreadly_language =
                            res.data.by_default_or_save_alreadly_language || "English";

                        // ✅ Get default language code from backend or fallback to English
                        const defaultCode = res.data.google_translate_language_code || "en";

                        // ✅ Find language object matching backend preference
                        const selected =
                            this.language_master_list.find(
                                (lang) =>
                                    lang.name === this.by_default_or_save_alreadly_language
                            ) ||
                            this.language_master_list.find((lang) => lang.name === "English");

                        if (selected) {
                            this.selected_language = selected;
                        }

                        this.hide_user_profile = res.data.hide_user_profile;
                        console.log("hide_user_profile========"+this.hide_user_profile);
                        

                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    }
                })
                .catch(() => {
                    this.overlay = false;
                   
                });
        },

        // ---- Save Selected Language ----
        savePreferredLanguage() {
            if (!this.selected_language || !this.selected_language.id) {
                this.showSnackbar("#b71c1c", "Please select a language first");
                return;
            }

            const params = {
                language_id: this.selected_language.id,
            };

            this.overlay = true;
            axios
                .post("/Home/savePreferredLanguage", params)
                .then((res) => {
                    this.overlay = false;

                    if (res.data.msg === "200") {
                        const lang = this.selected_language.google_translate_language_code;
                        localStorage.setItem("preferred_lang", lang);

                        document.cookie = `googtrans=/en/${lang};path=/`;
                        document.cookie = `googtrans=/en/${lang};path=/;domain=${window.location.hostname}`;

                        this.language_dialog = false;
                        window.location.reload();
                    } else {
                        this.showSnackbar("#b71c1c", res.data.msg);
                    }
                })
                .catch(() => {
                    this.overlay = false;
                    this.showSnackbar("#b71c1c", "Network error occurred.");
                });
        },


        SwitchToAdmin() {
            this.IsSwitched = !this.IsSwitched;
            sessionStorage.setItem('IsSwitched', this.IsSwitched);

            this.$router.replace({
                path: "/home",
                query: { IsSwitched: this.IsSwitched, IsAdminRole: this.IsAdminRole },
            });
            window.location.reload();

        },

        profile_link() {
            sessionStorage.setItem("para_role_type","Edit Profile");
            const userType = localStorage.getItem("EPS-ut");

            if (userType === "Parent" || userType === "Student") {
                if (["wws", "vvp", "eps", "sbpps", "sanjivani"].includes(this.tenant)) {
                    this.ut = "Parent";
                }
                this.profile = "/role-dashboard/edit-child-profile";
            } else if (userType === "Employee") {
                this.profile = "/role-dashboard/edit-emp-profile";
            } else {
                this.profile = null;
            }

            if (this.profile) {
                if (this.$route.path.includes("role-dashboard")) {
                    this.$router.push('/home'); // first go away

                    this.$nextTick(() => {
                        sessionStorage.removeItem("emp_role");
                        sessionStorage.removeItem("sblinks");
                        sessionStorage.removeItem("para_role");
                        sessionStorage.removeItem("para_role_type");


                        this.$router.push(this.profile); // then come back
                    });
                } else {
                    if (this.isDrawer == false) {
                        this.isDrawer1 = false;
                    }

                    this.$router.push(this.profile); // normal case
                }
            }
        },
        application_form() {
            const userType = localStorage.getItem("EPS-ut");

            if (userType === "Parent") {
                this.application_form_link = "/role-dashboard/new-application-form";


                if (this.application_form_link) {
                    if (this.$route.path.includes("role-dashboard")) {
                        this.$router.push('/home'); // first go away

                        this.$nextTick(() => {
                            sessionStorage.removeItem("emp_role");
                            sessionStorage.removeItem("sblinks");
                            sessionStorage.removeItem("para_role");
                            sessionStorage.removeItem("para_role_type");
                            if (this.isDrawer == false) {
                                this.isDrawer1 = false;
                            }
                            this.$router.push(this.application_form_link); // then come back
                        });
                    } else {
                        if (this.isDrawer == false) {
                            this.isDrawer1 = false;
                        }
                        this.$router.push(this.application_form_link); // normal case
                    }
                }
            }
        },
        virtual_card_link() {
            this.virtual_card = "/role-dashboard/virtual-card";

            if (this.virtual_card) {
                if (this.$route.path.includes("role-dashboard")) {
                    this.$router.push('/home'); // first go away

                    this.$nextTick(() => {
                        sessionStorage.removeItem("emp_role");
                        sessionStorage.removeItem("sblinks");
                        sessionStorage.removeItem("para_role");
                        sessionStorage.removeItem("para_role_type");


                        this.$router.push(this.virtual_card); // then come back
                    });
                } else {
                    if (this.isDrawer == false) {
                        this.isDrawer1 = false;
                    }

                    this.$router.push(this.virtual_card); // normal case
                }
            }
        },
        updatePhotoPath() {
            if (document.visibilityState === "visible") {
                const updatedPath = localStorage.getItem("learner_photo_path");
                if (updatedPath !== this.learnerPhotoPath) {
                    this.learnerPhotoPath = updatedPath;
                }
            }
        },
         openEmpRole(item) {
            // Store emp_role in sessionStorage
            sessionStorage.setItem("emp_role_dashboard_path", "/emp-role-dashboard");
            sessionStorage.setItem("emp_role", JSON.stringify(item));
            // Redirect user
            if (item.direct_link != null) {
                this.$router.push({ name: item.direct_link });
                return;
            }

            // this.$router.push("/emp-role-dashboard");
            this.emp_roles = JSON.parse(sessionStorage.getItem("emp_role")) || [];
        },
        openEmpRole1(item) {

            sessionStorage.removeItem("emp_role");
            sessionStorage.removeItem("sblinks");
            sessionStorage.removeItem("para_role");
            sessionStorage.removeItem("para_role_type");
            this.isDrawer1 = false;
            this.isDrawer = false;
            sessionStorage.setItem("emp_role", JSON.stringify(item));
            this.$router.push("/emp-role-dashboard");
        },
        openlink(child) {
            // Consider passing data via params for cleaner state management
            const newRoute = {
                name: child.link,
                query: {
                    role_type: child.para_role_type,
                    role_name: child.para_role,
                }
                // Add a unique query param ONLY if you absolutely need to force
                // the watch trigger even when params are identical.
                // query: { refresh: Date.now() } // Less ideal than watching params
            };

            // Optional: Still store in sessionStorage if needed elsewhere,
            // but prefer params for the component itself.
            sessionStorage.setItem("para_role", child.para_role);
            sessionStorage.setItem("para_role_type", child.para_role_type);

            // Use push or replace as needed. Push adds to history.
            this.$router.push(newRoute).catch(err => {
                // Catch NavigationDuplicated if you don't add a unique query
                if (err.name !== 'NavigationDuplicated') {
                    console.error(err);
                }
                // If caught, the component's watcher (see below) should still handle it
            });
        },
        openlink1(child) {
            sessionStorage.removeItem("emp_role_dashboard_path");
            sessionStorage.removeItem("emp_role");
            sessionStorage.removeItem("sblinks");
            this.isDrawer1 = false;
            this.isDrawer = false;
            // Consider passing data via params for cleaner state management
            const newRoute = {
                name: child.link,
                query: {
                    role_type: child.para_role_type,
                    role_name: child.para_role,
                }
                // Add a unique query param ONLY if you absolutely need to force
                // the watch trigger even when params are identical.
                // query: { refresh: Date.now() } // Less ideal than watching params
            };

            // Optional: Still store in sessionStorage if needed elsewhere,
            // but prefer params for the component itself.
            sessionStorage.setItem("para_role", child.para_role);
            sessionStorage.setItem("para_role_type", child.para_role_type);

            // Use push or replace as needed. Push adds to history.
            this.$router.push(newRoute).catch(err => {
                // Catch NavigationDuplicated if you don't add a unique query
                if (err.name !== 'NavigationDuplicated') {
                    console.error(err);
                }
                // If caught, the component's watcher (see below) should still handle it
            });
        },
        forceReload() {
            this.$router.replace({ path: this.$route.fullPath, query: { t: Date.now() } });
        },
        gotoLink() {
            if (this.goto_link != null) {
                if (this.search_links.includes(this.goto_link)) {
                    sessionStorage.removeItem("emp_role");
                    // sessionStorage.removeItem("para_role");
                    sessionStorage.removeItem("sblinks");

                    // Set correct session storage values
                    sessionStorage.setItem("is_from_search", true);
                    sessionStorage.setItem("search_para_role", this.goto_link.para_role);
                    sessionStorage.setItem("search_para_role_type", this.goto_link.search_para_role_type);
                    sessionStorage.setItem("search_link", this.goto_link.name);
                    // sessionStorage.setItem("para_role", this.goto_link.para_role);
                    // sessionStorage.setItem("para_role_type", this.goto_link.search_para_role_type)
                    this.isDrawer1 = false;
                    this.isDrawer = false;
                    this.$router.push({ name: this.goto_link.link });



                }
            }
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        async getAllNotifications() {
            try {
                const res = await axios.post("/communication/getAllCommunicationHistory");
                if (res.data.flag == "YES") {
                    this.comm_history = res.data.comm_history;
                    this.show_calendarnew = res.data.show_calendar;
                    this.conf_value = res.data.conf_value;
                    this.conf_link = res.data.conf_username;
                    localStorage.setItem("comm_history", JSON.stringify(this.comm_history));

                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
            } catch (err) {
                console.log("err", err);
                this.onerror(err);
            } finally {
                console.log("bye...");
            }
        },
        getInitials(name) {
            // Split the name into words, get the first letter of each word, and join them
            return name
                .split(" ")
                .map((word) => word[0].toUpperCase())
                .join("");
        },
        handleSwitchChange() {
            sessionStorage.removeItem("emp_role");
            sessionStorage.removeItem("sblinks");
            sessionStorage.removeItem("para_role");
            sessionStorage.removeItem("para_role_type");
            sessionStorage.removeItem("is_from_search")
            // sessionStorage.removeItem("sblinks");
            sessionStorage.setItem('isDrawer', this.isDrawer)
            if (!this.isDrawer) {
                this.isDrawer1 = true;
            }
            if (this.$route.path !== '/dummy') {
                this.$router.push("/home").catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        console.error("Router push error:", err);
                    }
                });
            }
        },
        openEditor() {
            this.clearSessionStroge();
            window.location.href = "/editor";
            // this.$router.push("/settings");
        },

        cancelDialogBoxForShowCalender() {
            this.DialogBoxForShowCalender = false;
        },
        OpenDialogBoxForShowCalender() {
            this.DialogBoxForShowCalender = true;
        },
        getParentNotification() {
            // alert("in getCalandar")
            axios
                .get("communication/getParentNotification")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.show_calendarnew = res.data.show_calendar;
                        this.conf_value = res.data.conf_value;
                        this.conf_link = res.data.conf_username;
                        this.comm_history = res.data.comm_history;
                        localStorage.setItem("comm_history", JSON.stringify(this.comm_history));
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                });
        },
        getCalandar() {
            axios
                .get("communication/getNotificationsCount")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.feedback_notification_count = res.data.new_feedback_list;
                        this.resolve_feedback_link = res.data.resolve_feedback_link;
                        console.log("Feedback count:", this.feedback_notification_count, "Link:", this.resolve_feedback_link);
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                });
        },
        showNotifications() {
            this.clearSessionStroge();
            window.location.href = "/show-notifications";
            // this.$router.push("/settings");
        },

        toggleDrawer() {
            this.$store.state.drawer = this.$store.state.drawer;
        },
        faq() {
            this.$router.push("/question-answer");
        },
        analyticalStats() {
            this.clearSessionStroge();
            window.location.href = "/analytical-dashboard";
            // this.$router.push("/analytical-dashboard");
        },

        analyticalStatsEmp() {

            this.clearSessionStroge();
            window.location.href = "/inst-analytical-dashboard";
        },
        showSettings() {
            this.clearSessionStroge();
            window.location.href = "/settings";
            // this.$router.push("/settings");
        },
        getMasterData() {
            this.clearSessionStroge();
            window.location.href = "/master-data";
            // this.$router.push("/master-data");
        },
        closeMenuAndLogout() {
            this.menu = false;
            sessionStorage.removeItem("isDrawer");
            axios
                .get("login/logout")
                .then((res) => {
                    console.log(res.data);
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    localStorage.clear();
                    localStorage.removeItem("preferred_lang");
                    // Remove Google translate cookie
                    document.cookie = "googtrans=;path=/;domain=" + window.location.hostname + ";expires=Thu, 01 Jan 1970 00:00:01 GMT;";
                    document.cookie = "googtrans=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
                    this.$router.push("/");
                    window.location.reload();
                });
            // alert("hi")

            return;

        },
        clearSessionStroge() {

            sessionStorage.removeItem("emp_role");
            sessionStorage.removeItem("sblinks");
            sessionStorage.removeItem("para_role");
            sessionStorage.removeItem("para_role_type");
        },
        bypasslogout() {
            this.menu = false;
            localStorage.setItem("EPS-token", localStorage.getItem("Mngt-EPS-token"));
            localStorage.setItem("EPS-uid", localStorage.getItem("Mngt-EPS-uid"));
            if (this.is_school_bypass_login) {
                // alert("ifff")
                this.$router.push("/bypass-management-inst");
                return;
            }
            this.$router.push("/eps-management-home");
            return;
        },
        routeToQuery() {
            if (localStorage.getItem("EPS-ut") == "Student") {
                this.$router.push("/role-dashboard/add-query");
            } else if (localStorage.getItem("EPS-ut") == "Employee") {
                this.$router.push("/role-dashboard/add-instructor-query");
            } else if (localStorage.getItem("EPS-ut") == "Parent") {
                this.$router.push("/role-dashboard/add-query");
            }
        },
        imageReplacement(uername) {
            //var names = this.uername.split('');
            //console.log("names "+names)
            this.initials = uername.charAt(0).toUpperCase();
            // window.alert(initials)
        },
        async call() {
            try {
                const res = await axios.post("/employeeDashboard/empProfileComponent");
                if (res.data.flag == "YES") {
                    this.name = res.data.name;
                    // this.photo_path = res.data.photo_path;
                    this.code = res.data.code;
                    this.mobile_no = res.data.mobile_no;
                    this.email = res.data.email;
                    this.blood_group = res.data.blood_group;
                    this.designation = res.data.designation;
                    this.employeetype = res.data.employeetype;
                    this.dob = res.data.dob;
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
            } catch (err) {
                console.log("err", err);
                this.onerror(err);
            } finally {
                console.log("bye...");
            }
        },
    },
    watch: {
        '$route.path'(newPath) {
            this.isDrawer1 = newPath === '/home';
        }
    },
    mounted() {
        this.getLanguages();
        this.usertype = localStorage.getItem("EPS-ut");
        const storedDrawer = sessionStorage.getItem('isDrawer');
        this.isDrawer = storedDrawer === 'true';
        if (this.user_type === "Parent") {
            if (localStorage.getItem("hasChildren") === "false") {
                console.log("Parent has no children → closing drawer");
                this.isDrawer = false;
                sessionStorage.setItem("isDrawer", "false");
            }
        }
        // Set isDrawer1 only if on /home
        this.isDrawer1 = this.$route.path === '/home';

        this.poller = setInterval(() => {
            const updated = localStorage.getItem("learner_photo_path");
            if (updated !== this.learnerPhotoPath) {
                this.learnerPhotoPath = updated;
            }
        }, 2000);
        this.isLoading = true;


        axios
            .get("/home/dashboardsidebar")
            .then((res) => {
                this.items = res.data.links;
                this.loading = false;
                this.module_link = res.data.to_show_module_management;
                this.search_links = res.data.search_links;
                this.erp_easycheck_flag = res.data.erp_easycheck_flag;
                this.erp_lib_flag = res.data.erp_lib_flag;
                this.show_parent_uid = res.data.show_parent_uid;
                this.parent_uid = res.data.parent_uid;
                this.show_addmission_form = true;
                this.isLoading = false;
                this.quick_links = res.data.quick_links;
                this.IsAdminRole = res.data.IsAdminRole;
                //added by vrushali

                if (res.data.erp_easycheck_flag == "YES") {
                    this.uid = res.data.uid;
                    this.easycheck_url = res.data.url;
                    this.erp_url = res.data.erp_url;
                    this.hash_key = res.data.key;
                    this.flag = true;
                }
                // alert(res.data.erp_lib_flag)
                if (res.data.erp_lib_flag == "YES") {
                    this.uid = res.data.uid;
                    this.prn = res.data.prn;
                    this.random_key = res.data.random;
                    this.lib_url = res.data.url;
                    this.erp_url = res.data.erp_url;
                    this.hash_key = res.data.key;
                    this.org_code = res.data.org_code;
                    this.flag = true;
                }

                // console.log("items", this.items);
                this.isLoading = false;
            })
            .catch((error) => {
                window.console.log(error);
                this.$router.push("/");
            });

        if (this.usertype === "Parent") {
            this.getParentNotification();
        } else if (this.usertype === "Employee") {
            this.getAllNotifications();
        }
        this.getCalandar();
        this.call();
        this.is_school_bypass_login = localStorage.getItem("is_school_bypass_login");
        this.reload_cnt--;
        this.home_url = this.$route.fullPath; //will get currentPath
        // console.log("url is", this.home_url);
        // console.log("mngt", localStorage.getItem("Mngt-EPS-uid"));
        if (localStorage.getItem("Mngt-EPS-uid") != null) this.show_bypasslogout = true;

        this.$store.commit("setquick_links", true);
        this.$store.commit("setcalendar_flag", true);
        this.$store.commit("settoday_events", true);

        this.awspath = localStorage.getItem("awspath");
        this.uid = localStorage.getItem("EPS-uid");
        this.org_name = localStorage.getItem("EPS-org-name");
        this.org_logo = localStorage.getItem("EPS-org-logo");

        this.username = localStorage.getItem("username");

        this.isDrawer = sessionStorage.getItem("isDrawer") === null
            ? true
            : sessionStorage.getItem("isDrawer") === "true",

            this.profile_image_name = localStorage.getItem("profile_image_name");
        this.profile_image_path = localStorage.getItem("profile_image_path");
        this.learnerPhotoPath = localStorage.getItem("learner_photo_path");


        this.imageReplacement(this.username);

    },
};
</script>
<style scoped>
.brand-light-card {
  background-color: color-mix(
    in srgb,
    var(--v-brand-base) 70%,
    var(--v-brandLight-base) 30%
  );
  color: white;
  transition: background-color 0.25s ease;
}
.link-card {
    width: 180px;
    height: 130px;
    padding: 20px !important;
    border-radius: 12px !important;
    transition: transform 0.2s ease;
}

    .icon-wrapper {
        background-color: white;
        border-radius: 50%;
        padding: 5px;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }


.link-card:hover {
    transform: translateY(-4px);
}

.linkname {
    font-size: 15px;
    color: var(--v-onBrand-base);
    font-weight: 600;
    font-family: Arial, Helvetica, sans-serif;
}

.toggle-switch {
    position: relative;
    display: inline-block;
    width: 3.5em;
    height: 1.8em;
    font-size: 1em;
    border-radius: 3em;
    overflow: hidden;
}

.toggle-switch input[type="checkbox"] {
    display: none;
}

.toggle-switch label {
    display: block;
    width: 100%;
    height: 100%;
}

.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #fff;
    border-radius: 3em;
    box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset;
    transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

.slider::before {
    position: absolute;
    content: "";
    width: 1.35em;
    height: 1.35em;
    left: 0.25em;
    bottom: 0.15em;
    top: 0.18em;
    background-color: var(--v-brand-base);
    border-radius: 50%;
    box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset;
    transition: transform 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55), background-color 0.3s ease;
    transform: perspective(800px) rotateY(0deg) rotateX(0deg);
}

.slider::after {
    position: absolute;
    content: "";
    width: 0.8em;
    height: 0.8em;
    left: 50%;
    bottom: 0.5em;
    background-color: #fff;
    border-radius: 50%;
    box-shadow: 0 0.1em 0.2em rgba(0, 0, 0, 0.3);
    transform: translate(-50%, 50%) scale(0);
    transition: transform 0.3s ease, opacity 0.3s ease;
    opacity: 0;
}

.toggle-switch input[type="checkbox"]:checked+.slider {
    background-color: #f2f2f2;
    box-shadow: 0 0.3em 0.3em rgba(244, 68, 68, 0.2);
}

.toggle-switch input[type="checkbox"]:checked+.slider::before {
    transform: translateX(1.6em) perspective(800px) rotateY(180deg) rotateX(360deg);
    background-color: var(--v-brand-base);
    box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset;
}

.toggle-switch input[type="checkbox"]:checked+.slider::after {
    transform: translate(-50%, 50%) scale(1);
}
.header-icons {
  color: var(--v-onBrand-base);
}

.header-icons .v-icon {
  color: var(--v-onBrand-base) !important;
}

@media (max-width: 600px) {
    .toggle-switch {
        transform: scale(0.85);
    }
}

.app-bar {
    background: var(--v-brand-base);
    height: 56px !important;
}

@media (max-width: 600px) {
    .v-toolbar__title {
        font-size: 1em !important;
        margin-left: 5px;
    }

    .v-avatar {
        margin: 0 2px !important;
    }
}



.rounded-card {
    border-radius: 20px;
    overflow: hidden;
}

.profile-card {
    min-width: 260px;
    max-width: 100%;
    width: auto;
    padding: 8px;
}

.profile-header {
    background: linear-gradient(to right, #f8f0e7, #edcef2);
}

.info-chip {
    background-color: white;
    border-radius: 8px;
    color: black;
    font-size: 12px;
    display: flex;
    flex-direction: column;
    white-space: normal;
    word-break: break-word;
}

.v-list-item-subtitle {
    white-space: normal !important;
    overflow-wrap: break-word;
}

.list-hover:hover {
    background-color: #f5f5f5 !important;
    transition: 0.3s;
}

.glow-avatar {
    box-shadow: 0 0 10px #b39ddb;
    border: 1px solid #fff;
}

.signout-wrap {
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: 0.2s ease-in-out;
}

.signout-text {
    margin-left: 3px;
    color: #b71c1c;
    font-weight: bold;
    font-size: 14px;
}

.signout-text:hover {
    text-decoration: underline;
}

.search-bar {
    background-color: white !important;
    color: black !important;
}

.search-bar input {
    color: black !important;
}

.search-bar .v-icon {
    color: black !important;
}

.search-bar ::placeholder {
    color: black !important;
}

.sidebar-link {
    text-decoration: none;
}

.sidebar-link-item:hover {
    background-color: rgb(181, 186, 190) !important;
}

.app {
    background: var(--v-brand-base);
}

.text {
    color: #0f2027;
}

.org-name {
    color: white;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 1.5em;
}

@media print {

    header,
    footer,
    nav,
    date {
        display: none !important;
    }

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"] {
        display: none !important;
    }
}

@media (max-width: 920px) {
    .org-name {
        color: white;
        font-family: "Comic Sans MS", "Comic Sans", cursive;
        font-size: 1em;
        margin-left: 0px;
        width: 100%;
    }

    .text {
        color: #0f2027;
        font-size: 20px !important;
    }

    .app-bar {
        /* height: 70px !important; */
    }
}

@media (max-width: 310px) {
    .org-name {
        color: white;
        font-family: "Comic Sans MS", "Comic Sans", cursive;
        font-size: 13px;
        margin-left: 0px;
        width: 100%;
        font-weight: bold;
    }

    .app-bar {
        height: 70px !important;
    }
}
</style>